var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-type-stats"},[_c('div',{ref:"liveContainer",attrs:{"id":"liveContainer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }